import PropTypes from 'prop-types';
import React from 'react';
import {Box, Card, CardContent, Typography, useTheme} from '@mui/material';

const HealthCard = ({label, value, subtitle, color}) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        flex: 1,
        minWidth: 140,
        borderLeft: `4px solid ${color || theme.palette.grey[400]}`,
      }}
    >
      <CardContent sx={{py: 1.5, '&:last-child': {pb: 1.5}}}>
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
        <Typography variant="h5" fontWeight={600}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="textSecondary">
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

HealthCard.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const QuotaHealthCards = ({summary}) => {
  const theme = useTheme();

  if (!summary) return null;

  const activeCount = summary.activeCount ?? 0;
  const pendingCount = summary.pendingCount ?? 0;
  const expiringSoonCount = summary.expiringSoonCount ?? 0;

  const cards = [
    {
      label: 'Active Products',
      value: activeCount,
      color: theme.palette.success.main,
      show: true,
    },
    {
      label: 'Pending',
      value: pendingCount,
      color: theme.palette.warning.main,
      show: pendingCount > 0,
    },
    {
      label: 'Expiring Soon',
      value: expiringSoonCount,
      subtitle: 'within 30 days',
      color: theme.palette.error.main,
      show: expiringSoonCount > 0,
    },
  ];

  const visible = cards.filter(c => c.show);

  return (
    <Box display="flex" gap={2} flexWrap="wrap" alignItems="stretch">
      {visible.map(card => (
        <HealthCard
          key={card.label}
          label={card.label}
          value={card.value}
          subtitle={card.subtitle}
          color={card.color}
        />
      ))}
    </Box>
  );
};

QuotaHealthCards.propTypes = {
  summary: PropTypes.shape({
    activeCount: PropTypes.number,
    pendingCount: PropTypes.number,
    expiringSoonCount: PropTypes.number,
    quotaRollup: PropTypes.arrayOf(
      PropTypes.shape({
        units: PropTypes.string,
        limit: PropTypes.number,
        used: PropTypes.number,
      })
    ),
  }),
};

export default QuotaHealthCards;
